import { render } from "./hands-on-process-tab.vue?vue&type=template&id=f7cb2b9e&scoped=true"
import script from "./hands-on-process-tab.vue?vue&type=script&lang=js"
export * from "./hands-on-process-tab.vue?vue&type=script&lang=js"

import "./hands-on-process-tab.vue?vue&type=style&index=0&id=f7cb2b9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7cb2b9e"]])

export default __exports__